import ReviewsSection from "./reviews";

export default ReviewsSection;